import { inputLabelClasses, InputLabelProps } from '@mui/material';
import { type Theme } from '@mui/material/styles';

declare module '@mui/material/InputLabel' {
  interface InputLabelPropsSizeOverrides {
    xsmall: true;
    medium: true;
    large: true;
    normal: false;
  }
}

export default function InputLabel(theme: Theme) {
  const rootStyles = (ownerState: InputLabelProps) => {
    const defaultStyle = {
      // color: `${theme.palette.grey[500]}!important`,
      ...theme.typography.body3,
      color: theme.palette.grey[700],
      // lineHeight: `1.5!important`,
      position: 'relative',
      transform: 'none',
      [`& > .${inputLabelClasses.asterisk}`]: {
        color: theme.palette.error.main,
      },
      [`&.${inputLabelClasses.shrink}`]: {
        // fontWeight: theme.typography.fontWeightMedium,
      },
      [`&.${inputLabelClasses.focused}`]: {
        color: theme.palette.grey[700],
      },
    };

    const disabledState = {
      [`&.${inputLabelClasses.disabled}`]: {},
    };

    return {
      ...defaultStyle,
      ...disabledState,
    };
  };

  return {
    MuiInputLabel: {
      defaultProps: {},

      styleOverrides: {
        root: ({ ownerState }: { ownerState: InputLabelProps }) =>
          rootStyles(ownerState),
      },
    },
  };
}
